import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { CompilationModel, PaymentPlanInvoice, PaymentPlanItem } from '../../../../../@models/erp/compilation';
import { IDropdownOptions, SharedDataService } from '../../../../../@core/service/shared-data.service';
import { SelectorDisplayMode } from '../../document-select/document-select.component';
import { InvoicePaymentData, InvoiceStatusData, PaymentStatusData } from '../../../../../@models/erp/compilationData';
import { TreeService } from '../../../../../@core/service/tree.service';
import { NbPopoverDirective } from '@nebular/theme';
import { getTotalNet, isEmpty, mongoId } from '../../../../../@core/common/global';
import { ApiService } from '../../../../../@core/service/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ngx-payment-plan-invoices',
  templateUrl: './payment-plan-invoices.component.html',
  styleUrls: ['./payment-plan-invoices.component.scss']
})
export class PaymentPlanInvoicesComponent implements OnChanges, OnDestroy {

  @Input() compilation: CompilationModel;
  @Input() paymentPlanInvoice: PaymentPlanInvoice;
  @Input() disabled: boolean;
  @Input() print: boolean;

  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;
  hidePopovers = () => this.popovers && this.popovers.forEach(el => el.hide());

  dlgMode = SelectorDisplayMode;
  invoiceStatusOptions = InvoiceStatusData.getOptions() as unknown as IDropdownOptions[];
  invoicePaymentOptions = InvoicePaymentData.getOptions() as unknown as IDropdownOptions[];
  hasInvoices = false;

  baseProductOptions = [];

  paymentPlanNumItems: number = 0;

  private subscriptions: Subscription[] = [];

  constructor(protected data: SharedDataService, protected cdRef: ChangeDetectorRef, protected tree: TreeService) { 
  //   this.subscriptions = [
  //     this.tree.documentTreeLoadedEvent.subscribe(s => {
  //       for (let ppIn of this.compilation.paymentPlan?.items?.flatMap(m => m.invoices)) {
  //         if (ppIn) {
  //           const inv = this.tree.paymentPlanInvoiceData?.treeInvoices?.find(f => f.doc?.code === ppIn.code);
  //           ppIn.code = inv.doc.code;
  //           ppIn.paymentType = inv.doc.invoicePayment;
  //           ppIn.issueDate = inv.doc.issueDate;
  //           ppIn.baseProduct = null;
  //           ppIn.net = -inv.doc.sumTotal;
  //           ppIn.paymentStatus = inv.doc.invoiceStatus;
  //           ppIn.paymentDate = inv.doc.paymentDate;
  //         }
  //       }
  //     })
  //   ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.compilation) {
      this.paymentPlanNumItems = this.compilation.paymentPlan?.items?.length
      console.log('==============>', this.compilation.paymentPlan);
    }
    setTimeout(() => {
      this.hasInvoices = !isEmpty(this.compilation.paymentPlan?.items?.find(f => f.invoices?.length > 0));
    });
    // console.log('ppinv hasInvoices', hasInvoices, this.hasInvoices)
    // this.hasInvoices = hasInvoices;
    
    // console.log('has invoices', this.hasInvoices, this.compilation.paymentPlan?.items, this.compilation.paymentPlan?.items?.find(f => f.invoices?.length > 0))
    this.baseProductOptions = this.data.baseProductOptions.filter(f => 
      this.compilation.lineItems?.map(m => mongoId(m.finishedProduct?.product)).includes(mongoId(f.id))
    );
    // console.log('ppinv', changes, this.hasInvoices, this.compilation.paymentPlan?.items);

  }

  setPaymentPlanInvoice(ppIn: PaymentPlanInvoice, inv: any) {
    // console.log('setPaymentPlanInvoice', inv);
    ppIn.code = inv.doc.code;
    ppIn.paymentType = inv.doc.invoicePayment;
    ppIn.issueDate = inv.doc.issueDate;
    ppIn.baseProduct = null;
    ppIn.net = /CNNRK/.test(inv.doc.code) ? Math.abs(inv.doc.sumTotal) : -Math.abs(inv.doc.sumTotal);
    ppIn.paymentStatus = inv.doc.invoiceStatus;
    ppIn.paymentDate = inv.doc.paymentDate;
    this.hidePopovers();
  }

  removePaymentPlanInvoice(ppItem: PaymentPlanItem, ppIn: PaymentPlanInvoice) {
    ppItem.invoices = ppItem.invoices.filter(f => f !== ppIn);
  }

}
